interface FeedIssueIconProps {
  size?: number;
  color?: string;
  className?: string;
}

// Warning triangle with an exclamation mark, marking feeds that repeatedly fail to fetch.
// Stroke-based to match the app's SVG-only icon style (no emoji).
const FeedIssueIcon: React.FC<FeedIssueIconProps> = ({ size = 16, color = 'currentColor', className }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'inline-block', verticalAlign: 'middle', color }}
    aria-hidden="true"
  >
    <path d="M8 1.75 15 14H1L8 1.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" fill="none" />
    <path d="M8 6.25v3.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="8" cy="11.75" r="0.9" fill="currentColor" />
  </svg>
);

export default FeedIssueIcon;
